import React, { useState } from 'react';
import { X } from 'lucide-react';
import InputField from './InputField'; // Note the import from the same folder

const AuthModal = ({ show, onClose, onLogin, onSignup, onGoogleSignIn, error, setAuthError }) => {
    const [isLogin, setIsLogin] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');

    if (!show) return null;
    
    const handleSubmit = (e) => {
        e.preventDefault();
        if (isLogin) {
            onLogin(email, password);
        } else {
            onSignup(email, password, name);
        }
    };
    
    const toggleMode = () => {
        setIsLogin(!isLogin);
        setAuthError('');
        setEmail('');
        setPassword('');
        setName('');
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-50">
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 md:p-8 w-full max-w-md shadow-2xl border border-gray-200 dark:border-gray-700 relative">
                <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-100 transition duration-200"><X size={24} /></button>
                <h2 className="text-3xl font-bold text-center text-gray-900 dark:text-cyan-400">{isLogin ? 'Login' : 'Sign Up'}</h2>
                <p className="text-center text-gray-600 dark:text-gray-400 mt-2">Create an account to save your institutional data.</p>
                <form onSubmit={handleSubmit} className="space-y-6 mt-6">
                    {!isLogin && (
                        <InputField label="Full Name" type="text" value={name} onChange={e => setName(e.target.value)} placeholder="e.g., Dr. Jane Doe" required />
                    )}
                    <InputField label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" required/>
                    <InputField label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required/>
                    {error && <p className="text-red-500 text-sm text-center">{error}</p>}
                    <button type="submit" className="w-full px-4 py-3 font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200">
                        {isLogin ? 'Log In' : 'Create Account'}
                    </button>
                </form>

                <div className="relative my-6">
                    <div className="absolute inset-0 flex items-center">
                        <div className="w-full border-t border-gray-300 dark:border-gray-600"></div>
                    </div>
                    <div className="relative flex justify-center text-sm">
                        <span className="px-2 bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-400">
                            Or continue with
                        </span>
                    </div>
                </div>

                <div className="space-y-3">
                    <button onClick={onGoogleSignIn} className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-gray-800 text-sm font-medium text-gray-500 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700">
                        Sign in with Google
                    </button>
                </div>

                <div className="text-center mt-4">
                    <button onClick={toggleMode} className="text-sm text-blue-600 dark:text-blue-400 hover:underline">
                         {isLogin ? "Don't have an account? Sign Up" : "Already have an account? Log In"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AuthModal;